import React from "react";
import { Route, Routes } from "react-router-dom";

// Styles
import './App.css'

import HomePage from "./components/homePage";

const AppContent = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <AppContent />
  );
};

export default App;